module.exports = __webpack_public_path__ + "950945c1d716d750c8ef93e1cb6da6b7.pdf";